<form [formGroup]="formTest" (ngSubmit)="save()">
  <div style="background:#0F1A41;color:white;text-align:center;vertical-align:middle;height:45px">
    <h2 mat-dialog-title style="padding-top:5px">{{title}}</h2>
  </div>
  <div class="flex-container">
    <mat-dialog-content style="padding:0px;margin:0px">
      <div>
        <div formGroupName="time">
          <div style="margin-left:15px;margin-top:12px">
            <mat-form-field>
              <mat-label class="mat-input-header">Förare</mat-label>
              <mat-select placeholder="Förare" formControlName="driver">
                <mat-option *ngFor="let driver of data.workShifts" [value]="driver.userMappingID">
                  {{driver.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label class="mat-input-header">Starttid</mat-label>
              <input matInput type="time" formControlName="startTime" />
            </mat-form-field>
          </div>
          <div>

          </div>
          <div style="margin-left:15px">
            <mat-label>Tidsåtgång (min): </mat-label>
            <label>{{durationControl.value}}</label>
          </div>
          <div style="margin-left:15px;margin-right:15px">
            <mat-slider formControlName="duration" min="1" [max]="data.activityEvent.duration > 100 ? data.activityEvent.duration * 1.5 : 100" step="1" (change)="onDurationChange()" thumb-label="true"
                        style="width:100%;margin-top:-10px"></mat-slider>
          </div>
          <div style="margin-left:15px" *ngIf="!timeGroup.valid && canEdit() && timeGroup.errors?.activity" class="cross-validation-error-message alert alert-danger">
            <label>Tiden överlappar ett existerande uppdrag.</label>
          </div>
          <div style="margin-left:15px" *ngIf="!timeGroup.valid && canEdit() && timeGroup.errors?.notWorking" class="cross-validation-error-message alert alert-danger">
            <label>Resursen arbetar inte den tiden.</label>
          </div>
        </div>
        <div style="margin-left:15px" *ngIf="hasStartLocation()">
          <mat-form-field>
            <mat-label class="mat-input-header">Startplats</mat-label>
            <mat-select placeholder="Startplats" formControlName="startLocation">
              <mat-option *ngFor="let location of data.locations" [value]="location.id">
                {{location.name}} ({{location.type}})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="margin-left:15px" *ngIf="hasEndLocation()">
          <mat-form-field>
            <mat-label class="mat-input-header">Destination</mat-label>
            <mat-select placeholder="EndLocation" formControlName="endLocation">
              <mat-option *ngFor="let location of data.locations" [value]="location.id">
                {{location.name}} ({{location.type}})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="margin-left:15px;margin-bottom:10px;" *ngIf="data.activityEvent.type == 'BKSADM' || data.activityEvent.type == 'BKSMISC'">
          <mat-form-field>
            <mat-label class="mat-input-header">Typ av aktivitet</mat-label>
            <mat-select #eventPicker placeholder="Aktivitet" formControlName="typeName" (selectionChange)="onChangeType($event.value)">
              <mat-option *ngFor="let eventType of eventTypes" [value]="eventType.name">
                <mat-icon *ngIf="!eventType.isSvgIcon">{{getEventIcon(eventType)}}</mat-icon>
                <mat-icon *ngIf="eventType.isSvgIcon" svgIcon="{{getEventIcon(eventType)}}"></mat-icon>
                {{eventType.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="showDescription()">
            <mat-label class="mat-input-header">Beskrivning</mat-label>
            <input matInput formControlName="description">
          </mat-form-field>
        </div>
        <div *ngIf="canBeBilled()" style="margin-left:15px;">
          <mat-checkbox formControlName="billed">Faktureras</mat-checkbox>
        </div>
        <div style="margin-left:15px;margin-right:15px;display:flex">
          <mat-form-field style="flex:1">
            <mat-label class="mat-input-header">Kommentar</mat-label>
            <div style="flex:1">
              <textarea matInput formControlName="comment" rows="4" placeholder="kommentar"></textarea>
            </div>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <div style="display: flex;flex-direction:row-reverse;margin-right:15px;margin-bottom:15px">
      <button mat-flat-button type="submit"
              style="margin-left:10px;background:#7AB800" [disabled]="!canSave()">
        Spara
      </button>
      <button mat-button type="button" (click)="unassign()" [hidden]="!canUnassign()" [disabled]="!canUnassign()"
              style="margin-left:10px;background:#FF402B;border-color:grey;color:white;border-style:solid;border-width:1px">
        Avboka flight
      </button>
      <button mat-button type="button" (click)="cancelActivity()" [hidden]="!canCancelActivity()" [disabled]="!canCancelActivity()"
              style="margin-left:10px;background:#FF402B;border-color:grey;color:white;border-style:solid;border-width:1px">
        Avbryt uppdrag
      </button>
      <button mat-button type="button" (click)="cancel()"
              style="margin-left:10px;background:transparent;border-color:grey;color:grey;border-style:solid;border-width:1px">
        Stäng
      </button>
    </div>
  </div>
</form>
